import { render, staticRenderFns } from "./CellRendererLogo.vue?vue&type=template&id=3ff346ed&"
import script from "./CellRendererLogo.vue?vue&type=script&lang=js&"
export * from "./CellRendererLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports